import {Component, Input, OnInit} from '@angular/core';
import {MetaDataService} from '../../../services/metaData/meta-data.service';

@Component({
  selector: 'pcons-summary',
  templateUrl: './pcons-summary.component.html',
  styleUrls: ['./pcons-summary.component.scss']
})
export class PconsSummaryComponent implements OnInit {

  @Input() selection: any;

  constructor(private metaDataService: MetaDataService) {

  }

  ngOnInit(): void {
  }

  generateAdministrativeStateLabel(): string {
    return this.metaDataService.PeerConnectionAdminStatus[this.selection[0].adminState].label;
  }

}
